import React from 'react';
import QRCode from 'react-qr-code';

const QRCodeGenerator = ({ value, size = 160, label }) => {
  return (
    <div style={{ textAlign: 'center' }}>
      {label && (
        <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
          {label}
        </div>
      )}
      <div style={{ height: `${size}px`, width: `${size}px`, margin: "0 auto", background: 'white', padding: '8px' }}>
        <QRCode value={value} style={{ height: "100%", width: "100%" }} />
      </div>
    </div>
  );
};

export default QRCodeGenerator;
